import Vue from 'vue'
import initialState from './state'

export default {
  SET_ACCESS_TOKEN (state, accessToken) {
    state.accessToken = accessToken
  },

  SET_PAGE_TITLE (state, pageTitle) {
    state.pageTitle = pageTitle
    if (pageTitle === '') {
      document.title = 'Charles'
    } else {
      document.title = pageTitle + ' - Charles'
    }
  },

  SET_CURRENT_ROUTE_NAME (state, currentRouteName) {
    state.currentRouteName = currentRouteName
  },

  SET_REQUEST_TIME_CACHE_ITEM (state, cacheItem) {
    Vue.set(state.requestTimestamps, cacheItem.key, cacheItem.timestamp)
  },

  SET_RESPONSE_TIME_CACHE_ITEM (state, cacheItem) {
    Vue.set(state.responseTimestamps, cacheItem.key, cacheItem.timestamp)
  },

  SET_LAST_CHANGELOG_DISMISSED (state, changelogVersion) {
    state.lastChangelogDismissed = changelogVersion
  },

  CLEAR_LAST_CHANGELOG_DISMISSED (state) {
    state.lastChangelogDismissed = false
  },

  CLEAR_REQUEST_TIME_CACHE (state) {
    Vue.set(state, 'requestTimestamps', {})
  },
  CLEAR_RESPONSE_TIME_CACHE (state) {
    Vue.set(state, 'responseTimestamps', {})
  },
  CLEAR_ALL (state) {
    for (let key in initialState) {
      Vue.set(state, key, initialState[key])
    }
  }
}
